import { axiosClient } from 'www/utils'
import type {
  ApiCitiesResponseGet,
} from 'www/vue_components/common/TheFilters/doctors/api/apiCities.types'

export default {
  get() {
    return axiosClient.get<ApiCitiesResponseGet>('/api/town/telemed/')
  },
}
